import React, { useEffect } from 'react';

function Affiliate() {
  useEffect(() => document.getElementById("start").scrollIntoView({ behavior: "smooth", block: "center" }));

  return (
    <div className="page">
      <h1 id="start">Become an Affiliate</h1>
      <p>Last updated: 1st May 2018</p>
      <p>Parcels Today is happy to present you with the Parcels Today affiliate program where individuals who happen
       to know hard working riders/vehicle owners and would like to introduce our team to them can do so to earn amazing prizes.</p>
      <p>Anyone can take part in our affiliate program simply email us letting us know about your interest and we'll get you set up.</p>
      <h3>Contact Us</h3>
      <p>If you have any questions regarding the affiliate program, please contact us at </p>
      <a href="mailto:team@parcelstoday.com" target="_blank">team@parcelstoday.com</a>
    </div>
  )
}

export default Affiliate;